/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { UploadCreatorMediaResponse, UploadCreatorMediaVars } from '../openapi-types.gen.js';

export type { UploadCreatorMediaResponse, UploadCreatorMediaVars } from '../openapi-types.gen.js';

export const useUploadCreatorMedia = createMutationHook<UploadCreatorMediaVars, UploadCreatorMediaResponse, unknown>({
  specName: 'useUploadCreatorMedia',
  path: '/v1/admin/creators/media',
  method: 'POST',
  resolveUrl: (vars: UploadCreatorMediaVars) => `/v1/admin/creators/media`,
  buildBody: (vars: UploadCreatorMediaVars) => vars,
  parseResponse: (raw: unknown): UploadCreatorMediaResponse => raw as UploadCreatorMediaResponse,
  
  
  
});
